/**
 * rs-quick-pill — mobile tap-to-expand behavior for the card quick-add pill.
 *
 * The pill is rendered by snippets/quick-add.liquid as:
 *   <div class="rs-quick-pill" data-rs-expanded="false">
 *     <button class="rs-quick-pill__toggle">...</button>   // collapsed state (mobile only)
 *     <div class="rs-quick-pill__controls">
 *       {% render 'quantity-selector' %}                   // theme stepper
 *       {% render 'add-to-cart-button' %}                  // theme add-to-cart
 *     </div>
 *   </div>
 *
 * Desktop (>=750px) always shows .rs-quick-pill__controls via CSS, using the
 * card's hover state to reveal/hide the pill. Mobile (<750px) toggles between
 * .rs-quick-pill__toggle and .rs-quick-pill__controls based on data-rs-expanded.
 *
 * Add button disabled state is server-rendered by the theme (only when the
 * variant is unavailable), so we don't touch it here — qty starts at 1.
 *
 * Script is idempotent via window.__rsQuickPillInit so it's safe to load
 * multiple times (snippet is rendered once per product card).
 */
if (!window.__rsQuickPillInit) {
  window.__rsQuickPillInit = true;

  (function () {
    /** @param {HTMLElement} pill */
    function getInput(pill) {
      return pill.querySelector('input[type="number"]');
    }

    /** @param {HTMLElement} pill */
    function expand(pill) {
      pill.setAttribute('data-rs-expanded', 'true');
      const toggle = pill.querySelector('.rs-quick-pill__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      // Focus the + button so keyboard users can bump qty immediately.
      const plus = pill.querySelector('.quantity-plus');
      if (plus) setTimeout(() => plus.focus(), 0);
    }

    /**
     * @param {HTMLElement} pill
     * @param {boolean} resetQty
     */
    function collapse(pill, resetQty) {
      pill.setAttribute('data-rs-expanded', 'false');
      const toggle = pill.querySelector('.rs-quick-pill__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (resetQty) {
        const input = getInput(pill);
        if (input) input.value = '1';
      }
    }

    document.addEventListener('click', (e) => {
      const target = /** @type {HTMLElement | null} */ (e.target);
      if (!target || typeof target.closest !== 'function') return;

      // Tap on the toggle (collapsed cart icon) → expand.
      const toggle = target.closest('.rs-quick-pill__toggle');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        const pill = toggle.closest('.rs-quick-pill');
        if (pill) expand(/** @type {HTMLElement} */ (pill));
        return;
      }

      // Any click outside an expanded pill → collapse it.
      const openPills = document.querySelectorAll('.rs-quick-pill[data-rs-expanded="true"]');
      openPills.forEach((p) => {
        if (!p.contains(target)) collapse(/** @type {HTMLElement} */ (p), false);
      });
    });

    // Collapse + reset after a successful add. cart:update bubbles from the
    // cart drawer and the product-form-component after a successful fetch.
    document.addEventListener('cart:update', () => {
      document.querySelectorAll('.rs-quick-pill').forEach((p) => {
        collapse(/** @type {HTMLElement} */ (p), true);
      });
    });
  })();
}
